/**
 * `router/home.js`
 *  - TOPページ用スクリプト
 *
 * 使用方法:
 *  - /router/index.js initRouterで動的読み込み
 *  - import {homeRouter} from "./router/home.js";
 */
import {getContainer} from "../utils/index.js";


export const homeRouter = (data) => {
  console.log("📖 Initializing home page...");

  const body = document.body;
  const container = getContainer(data.next.container);

  // ランディング時とページ内遷移時で表示を変える処理
  if (data.current.namespace === null || data.current.namespace === '') {
    body.classList.add("is-landing");
    const kv = container.querySelector(".kv");
    if (kv) {
      kv.style.display = "none";
    }

    const concept = container.querySelector(".home_concept");
    if (concept) {
      concept.style.display = "none";
    }
  } else {
    /*
    // パウロ分岐時 無効化
    body.classList.add("is-landing");
    const kv = container.querySelector(".kv");
    if (kv) {
      kv.style.display = "none";
    }

    const concept = container.querySelector(".home_concept");
    if (concept) {
      concept.style.display = "none";
    }
    // パウロ分岐時 無効化 ここまで
    */

    body.classList.remove("is-landing");
    const kv = container.querySelector(".landing_kv");
    if (kv) {
      kv.style.display = "none";
    }

    const concept = container.querySelector(".landing_concept");
    if (concept) {
      concept.style.display = "none";
    }
  }
}